import { defineStore } from 'pinia'
import repositoryFactory from '@/factories/repository-factory'
import AlertHistoryRepository, { AlertHistoryParams } from '@/repositories/alert-history-repository'
import AlertHistories from '@/models/AlertHistories'

const storeKey = 'alertHistory'

export const useAlertHistoryStore = defineStore(storeKey, {
  state: () => ({
    history: new AlertHistories([]),
  }),

  actions: {
    async fetch(params: AlertHistoryParams) {
      const repository = (await repositoryFactory.create()).get(storeKey) as AlertHistoryRepository

      this.history = await repository.get(params)
      this.history.histories = this.history.histories.sort((a, b) => (b.startTime > a.startTime ? 1 : -1))
    },
  },
})
